import {createFileRoute} from '@tanstack/react-router';
import {AgreementListPage} from 'features/agreement-cancellation/pages/AgreementListPage/AgreementListPage';

export const Route = createFileRoute('/_protected/agreements/')({
  component: AgreementListPage,
  staticData: {crumbKey: 'navigation.agreements'},
});
